import { ModalWindow } from "../../../UI/ModalWindow";
import { Input, Select } from '../../../UI/FormElements'

const ROUTE_URL = "/outsystem";
const initialData = { adress: "", port: "", name: "", source_format_name: "", active: "0" };

function ModalOutSystem({ params, handleClose }) {
  console.log("params", params);
  let urlSubmit, urlGet;
  if (params.isNew) {
    urlSubmit = ROUTE_URL;
    urlGet = ""; //или ROUTE_URL + "/create" если при создании НАДО предварительное обращение к серверу

  }
  else {
    urlGet = ROUTE_URL + "/" + params.id;
    urlSubmit = urlGet;

  }

  console.log(urlGet);
  console.log('initialDatainitialDatainitialData', initialData);

  return (
    <ModalWindow params={params} handleClose={handleClose} initialData={initialData} urlGet={urlGet} urlSubmit={urlSubmit} >
      <IncidentCardsFields />
    </ModalWindow>
  );
}
let categoryTypes = [{ id: 1, name: "Новое" }, { id: 2, name: "В работе" }, { id: 3, name: "Просрочено" }, { id: 4, name: "Выполнено" }, { id: 5, name: "В архиве" }];

const IncidentCardsFields = ({ dopParams, ...elementProps }) => {
  console.log('elementPropselementPropselementProps', elementProps);
  return (
    <div className="row form-gutter">
      <div className="col-12 rowcols">
        <div className="rowcol">
          <Input label="Название" name="name" {...elementProps} required />
        </div>
        <div className="rowcol checkbox">
          <Input type="checkbox" className="form-check-input actcheck" label="Включен" name="active" {...elementProps} onChange={(e) => e.target.checked ? elementProps.data.active = 1 : elementProps.data.active = 0} />
        </div>
      </div>
      <div className="col-12">
        <Input label="Адрес мониторинга" name="adress"  {...elementProps} required autoFocus />
      </div>
      <div className="col-12 rowcols">
        <div className="rowcol">
          <Input label="Формат данных" name="source_format_name" {...elementProps} required />
        </div>
        <div className="rowcol">
          <Input label="Порт" name="port" {...elementProps} required />
        </div>
      </div>
    </div>
  )
}
export default ModalOutSystem;
